<template>
    <div class="task-item-card" @click="emit('click')">
        <div class="task-icon" ><div :class="taskIcon[props.taskInfo.key]"></div></div>
        <div class="task-content">
            <div class="task-title-row">
                <span class="task-title">{{ props.taskInfo.name }}</span>
                <span class="task-reward">
                    <span class="task-ticket">
                        <img class="ticket-icon" src="@/assets/images/icon-piao.png" alt="">
                        <span class="ticket-num qm-number">{{ '1' }}</span>
                    </span>
                    <span class="task-progress" v-if="!['sign_in', 'share'].includes(props.taskInfo.key)">{{ props.taskInfo?.name_more }}</span>
                </span>
            </div>
            <div class="task-subtitle">{{ props.taskInfo.sub_title }}</div>
        </div>
        <div class="task-item-right" @click="handleBtnClick">
            <span class="task-btn" :class="{ 'task-btn-done': props.taskInfo.status === '1', 'task-btn-light': props.taskInfo.status === '2' }">
                {{ buttonText }}
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const emit = defineEmits(['receiveAward', 'goToFinish']);

const props = defineProps<{
    taskInfo: {
        name: string;
        sub_title: string;
        progress: string;
        button_text: string;
        status: string; // 0 未完成 1 已完成
        key: string;
        finish_num: number;
        can_finish_num: number;
    };
}>();

const taskIcon = {
    'sign_in': 'icon-sign',
    'read': 'icon-read',
    'reward': 'icon-vouchers',
    'community': 'icon-listen',
    'share': 'icon-share',
};

const buttonText = computed(() => {
    const textMap = {
        '1': '已完成',
        '2': '领投票',
    };
    return textMap[props.taskInfo.status.toString()] || '去完成';
});

const handleBtnClick = () => {
    console.log('props.taskInfo', props.taskInfo);
    if (props.taskInfo.status === '2') {
        emit('receiveAward');
    } else if (props.taskInfo.status === '0') {
        emit('goToFinish', props.taskInfo);
    }
};

</script>

<style lang="scss" scoped>
.task-item-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 26px 24px;
    background: #fff;
    border-radius: 20px;
    box-sizing: border-box;
}

.task-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #FFF0DD;
}

.task-icon-wrap {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ffe8d6 0%, #ffd4b8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 24px;
}

.task-icon-calendar {
    width: 44px;
    height: 44px;
    color: #e85c2c;
}

.task-content {
    flex: 1;
    margin-left: 16px;
}

.task-title-row {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
}

.task-title {
    font-weight: bold;
    font-size: 28px;
    color: #111111;
    line-height: 40px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.task-reward {
    display: flex;
    align-items: center;
}

.task-ticket {
    display: flex;
    align-items: center;
}
.ticket-icon {
    width: 36px;
    margin: 0 4px 0 8px;
}
.ticket-num {
    font-weight: bold;
    font-size: 24px;
    color: #FF7B00;
}

.task-progress {
    font-size: 22px;
    color: #666666;
    line-height: 32px;
    margin-left: 8px;
}

.task-subtitle {
    font-size: 22px;
    color: #666666;
    line-height: 32px;
}

.task-item-right {
    flex-shrink: 0;
    margin-left: 20px;
}

.task-btn {
    display: inline-block;
    width: 144px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-radius: 28px;
    font-weight: bold;
    font-size: 24px;
    color: #fff;
    background: linear-gradient( 270deg, #FFA500 0%, #FF910C 50.17%, #FF8C0C 100%);
}

.task-btn-done {
    opacity: 0.4;
}
.task-btn-light {
    background: linear-gradient( 270deg, #FF603D 0%, #FF6500 50.77%, #FF7F00 100%);
}
</style>
